import { FC } from 'react';

import FormulationSyrupTypeListing from 'components/main/FormulationSyrupType';

const FormulationSyrupType: FC = () => <FormulationSyrupTypeListing />;

export default FormulationSyrupType;
